import React from 'react';
import type {IMenuItem} from '../interfaces/IMenuItem';

const Menu: React.FC<{ items: IMenuItem[] }> = ({ items }) => {
    return (
        <ul>
            {items.map((item, index) => (
                <li key={index}>
                    <a href={item.url}>{item.title}</a>
                </li>
            ))}
        </ul>
    );
};

export default Menu;